import Script from "next/script";
import { SinglePage } from "../components/single_page";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let hbspt: any;

const Contact = () => {
  return (
    <SinglePage title="Contact us">
      <div id="hubspot-form"></div>
      <Script
        src="//js.hsforms.net/forms/shell.js"
        onLoad={() => {
          hbspt.forms.create({
            region: "na1",
            portalId: "21615365",
            formId: "c8f4e1a9-3c35-4819-8f9a-e9137f170b93",
            target: "#hubspot-form",
          });
        }}
      />
    </SinglePage>
  );
};

export default Contact;
